import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const GetMatchingSetPendingProducts = (params?: Record<string, unknown>) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.MatchingSetPendingReportQueryURL.GetMatchingSetPendingProducts,
        method: RequestType.GET,
        params,
    });

export const MatchingSetPendingReportQuery = {
    GetMatchingSetPendingProducts,
};
